<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-calendar-text</v-icon>
        <h1 class="page-title">{{ pageTitle }}</h1>
      </v-layout>
    </div>
    <h2></h2>

    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-text-field v-model="tournament.title" label="Title" required>
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-text-field
              v-model="tournament.entryFee"
              label="Entry Fee"
              prefix="$"
              type="number"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-text-field
              v-model="tournament.course"
              label="Course"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-text-field
              v-model="tournament.start"
              label="Start"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="tournament.description"
              label="Description"
              required
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <datetimectrl
              :datetime="tournament.signUpStart"
              label="Signup Start"
              @dateChanged="signUpStartChanged"
            ></datetimectrl>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <datetimectrl
              :datetime="tournament.signUpEnd"
              label="Signup End"
              @dateChanged="signUpEndChanged"
            ></datetimectrl>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <datetimectrl
              :datetime="tournament.eventStart"
              label="Event Start"
              @dateChanged="eventStartChanged"
            ></datetimectrl>
          </v-col>
        </v-row>
        <v-row> </v-row>
        <v-row>
          <v-col cols="12">
            <datetimectrl
              :datetime="tournament.eventEnd"
              label="Event End"
              @dateChanged="eventEndChanged"
            ></datetimectrl>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn outlined color="accent" class="mr-4" @click="onBack"
            >Back</v-btn
          >
          <v-btn outlined class="mr-4" @click="onSubmit"
            >Submit</v-btn
          >
        </v-row>
      </v-container>
    </v-form>
    <statusalert ref="alert" returnUrl="/schedule"></statusalert>
  </div>
</template>
<script>
import EventsService from '../../services/api/EventsService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import datetimectrl from '../../components/DateTime'
import statusalert from '../../components/StatusAlert'
import moment from 'moment'
import authorizedMixin from '../../mixins/authorizedMixin'

export default {
  name: 'tournament-edit',
  mixins: [authorizedMixin],
  store: store,
  components: {
    datetimectrl,
    statusalert
  },

  data() {
    return {
      result: null,
      pageTitle: 'Add Tournament',
      tournament: {
        title: '',
        entryFee: 25,
        course: 'Peak/Plains',
        start: '',
        description: '',
        signUpStart: '',
        signUpEnd: '',
        eventStart: '',
        eventEnd: ''
      },
      eventStartTime: '08:00',
      eventEndTime: '16:00',
      signUpStartTime: '06:00',
      signUpEndTime: '06:00'
    }
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },

  created() {
    if (!this.priviledged) {
      router.push('/unauth/')
    }

    if (this.$route.params.eventId > 0) {
      this.pageTitle = 'Edit Tournament'
      EventsService.getEvent(this.$route.params.eventId)
        .then(data => {
          this.tournament = data
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    } else {
      let dt = moment().add(2, 'months')
      dt.set({ hour: 8, minute: 0, second: 0, millisecond: 0 })
      const dtStr = dt.format()
      const eventEnd = dt.add(6, 'hours').format()
      let signup = dt
      signup.set({ hour: 6, minute: 0, second: 0, millisecond: 0 })
      const signUpEnd = signup.subtract(7, 'days').format()
      const signUpStart = signup.subtract(7, 'days').format()
      this.tournament = {
        course: 'Peak/Plains',
        description: '',
        entryFee: 25.0,
        eventEnd: eventEnd,
        eventStart: dtStr,
        signUpEnd: signUpEnd,
        signUpStart: signUpStart,
        start: 'Tee Times',
        title: 'Individual Low Gross / Low Net'
      }
    }
  },

  methods: {
    getSignUpStart() {
      return this.tournament.signUpStart
    },
    signUpStartChanged(newDate) {
      this.tournament.signUpStart = newDate
    },
    signUpEndChanged(newDate) {
      this.tournament.signUpEnd = newDate
    },
    eventStartChanged(newDate) {
      this.tournament.eventStart = newDate
    },
    eventEndChanged(newDate) {
      this.tournament.eventEnd = newDate
    },
    onSubmit() {
      this.tournament.entryFee = parseInt(this.tournament.entryFee)
      var me = this;
      if (this.$route.params.eventId > 0) {
        EventsService.update(this.tournament)
          .then(result => {
            me.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Event saved']
            }
          })
          .catch(error => {
            console.log(error)
            me.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to update event']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            me.displayAlert()
          })
      } else {
        EventsService.create(this.tournament)
          .then(result => {
            me.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['New event created']
            }
          })
          .catch(error => {
            console.log(error)
            me.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to create event']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            me.displayAlert()
          })
      }
    },
    onBack() {
      router.push('/schedule')
    },

    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    }
  }
}
</script>
<style lang="scss" scoped>
.button {
  padding: 5px;
}

.v-picker__title {
  height: 88px;
}
</style>
